(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gq-digital-groups-bak-1017"] && !Shopify.designMode) return;
  try {
    
function initializeGqDigitalGroups(root=document){for(const section of root.querySelectorAll('[data-gq-digital-groups]')){if(section.dataset.gqReady)continue;section.dataset.gqReady='true';const select=section.querySelector('[data-gq-edition-filter]');if(!select)continue;select.parentElement.hidden=false;select.addEventListener('change',()=>{for(const family of section.querySelectorAll('.gq-digital-groups__family')){let visible=0;for(const card of family.querySelectorAll('[data-gq-edition]')){card.hidden=select.value!=='all'&&card.dataset.gqEdition!==select.value;if(!card.hidden)visible++;}const empty=family.querySelector('[data-gq-empty]');if(empty)empty.hidden=visible>0;}});}}
initializeGqDigitalGroups();document.addEventListener('shopify:section:load',()=>initializeGqDigitalGroups());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gq-digital-groups"] && !Shopify.designMode) return;
  try {
    
function initializeGqDigitalGroups(root=document){for(const section of root.querySelectorAll('[data-gq-digital-groups]')){if(section.dataset.gqReady)continue;section.dataset.gqReady='true';const select=section.querySelector('[data-gq-edition-filter]');if(!select)continue;select.parentElement.hidden=false;select.addEventListener('change',()=>{for(const family of section.querySelectorAll('.gq-digital-groups__family')){let visible=0;for(const card of family.querySelectorAll('[data-gq-edition]')){card.hidden=select.value!=='all'&&card.dataset.gqEdition!==select.value;if(!card.hidden)visible++;}const empty=family.querySelector('[data-gq-empty]');if(empty)empty.hidden=visible>0;}});}}
initializeGqDigitalGroups();document.addEventListener('shopify:section:load',()=>initializeGqDigitalGroups());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gq-product-showcase-bak-1017"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gq-showcase').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
  const slides=[...root.querySelectorAll('.gq-showcase__slide')];
  const controls=root.querySelector('.gq-showcase__controls');
  if(!slides.length){root.hidden=true;return;}
  if(slides.length<2){controls.hidden=true;return;}
  let current=0;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let paused=root.dataset.autoplay!=='true'||reduced.matches;
  const pause=root.querySelector('[data-pause]');
  const label=()=>{pause.textContent=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;};
  const show=delta=>{slides[current].hidden=true;current=(current+delta+slides.length)%slides.length;slides[current].hidden=false;root.querySelector('[data-count]').textContent=current+1;};
  root.querySelector('[data-prev]').addEventListener('click',()=>{paused=true;label();show(-1);});
  root.querySelector('[data-next]').addEventListener('click',()=>{paused=true;label();show(1);});
  pause.addEventListener('click',()=>{paused=!paused;label();});
  label();
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(!paused&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement))show(1);},6500);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gq-product-showcase"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.gq-showcase').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
  const slides=[...root.querySelectorAll('.gq-showcase__slide')];
  const controls=root.querySelector('.gq-showcase__controls');
  if(!slides.length){root.hidden=true;return;}
  if(slides.length<2){controls.hidden=true;return;}
  let current=0;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let paused=root.dataset.autoplay!=='true'||reduced.matches;
  const pause=root.querySelector('[data-pause]');
  const label=()=>{pause.textContent=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;};
  const show=delta=>{slides[current].hidden=true;current=(current+delta+slides.length)%slides.length;slides[current].hidden=false;root.querySelector('[data-count]').textContent=current+1;};
  root.querySelector('[data-prev]').addEventListener('click',()=>{paused=true;label();show(-1);});
  root.querySelector('[data-next]').addEventListener('click',()=>{paused=true;label();show(1);});
  pause.addEventListener('click',()=>{paused=!paused;label();});
  label();
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(!paused&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement))show(1);},6500);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gq-revenue-hub"] && !Shopify.designMode) return;
  try {
    
function gqRevenueInit(){for(const root of document.querySelectorAll('[data-gq-revenue]')){const select=root.querySelector('[data-gq-bundle-filter]');if(!select||select.dataset.ready)continue;select.dataset.ready='true';select.parentElement.hidden=false;select.addEventListener('change',()=>{let shown=0;for(const card of root.querySelectorAll('[data-gq-bundle-edition]')){card.hidden=select.value!=='all'&&card.dataset.gqBundleEdition!==select.value;if(!card.hidden)shown++;}root.querySelector('[data-gq-bundle-empty]').hidden=shown>0;});}}
gqRevenueInit();document.addEventListener('shopify:section:load',gqRevenueInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
